import { Flex, Typography, Button, Icons } from 'components';
import { ReactElement } from 'react';
import styled from 'styled-components';

interface AuthenticatorProblemProps {
  onClick: () => void;
  onClickLink: () => void;
}
const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_300};
  margin-right: 8px;
`;

const AuthenticatorProblem = ({ onClick, onClickLink }: AuthenticatorProblemProps): ReactElement => {
  return (
    <Flex alignSelf="center" flexDirection="column" padding={24} justifyContent="space-between" maxWidth={600} backgroundColor="white">
      <Flex justifyContent="center">
        <Flex marginBottom={16} justifyContent="center">
          <Typography fontWeight="bold" color="dark_350" textAlign="center">
            Problemas com o app autenticador?
          </Typography>
        </Flex>
        <Flex maxWidth={530} justifyContent="center">
          <Flex marginBottom={32} justifyContent="center">
            <Typography type="type1" color="dark_350" textAlign="center">
              Não é necessário conexão de internet no celular para essa etapa. Acesse o celular onde você instalou o aplicativo autenticador (Google
              Authenticator, Microsoft Authenticator, etc.)
            </Typography>
          </Flex>
        </Flex>

        <Flex marginBottom={32}>
          <Typography fontWeight="bold" color="primary_400">
            Verifique o timer do código
          </Typography>
          <Flex marginTop="8px">
            <Typography type="type1" color="dark_350">
              Os códigos gerados pelos aplicativos tem geralmente 30 segundos de duração, e mudam depois desse período. O código que você digitou pode
              ter expirado antes da confirmação.
            </Typography>
          </Flex>
        </Flex>
        <Flex marginBottom={32}>
          <Typography fontWeight="bold" color="primary_400">
            Acesse nosso FAQ
          </Typography>
          <Flex marginTop="8px">
            <Typography type="type1" color="dark_350">
              Acesse a seção de Autenticação em dois fatores do FAQ da MELVER para buscar a sua dúvida específica.
            </Typography>
          </Flex>
        </Flex>

        <Flex marginBottom={32} flexDirection="row" justifyContent="space-between" alignItems="center">
          <Flex>
            <Icon icon="info" />
          </Flex>

          <Flex maxWidth={500}>
            <Typography type="type1" color="light4">
              A MELVER nunca solicita códigos por telefone ou aplicativos de mensagem. Não compartilhe seu código com outras pessoas.
            </Typography>
          </Flex>
        </Flex>
      </Flex>

      <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
        <Button type="button" p={24} bg="primary_400" color="white" colorHover="white" size="small" onClick={onClick}>
          Tentar novamente
        </Button>
        <Button
          outline
          bg="transparent"
          size="small"
          color="primary_400"
          onClick={() => onClickLink()}
          style={{ textTransform: 'inherit', fontWeight: 'normal', border: 0 }}
        >
          Acessar com código de recuperação
        </Button>
      </Flex>
    </Flex>
  );
};

export default AuthenticatorProblem;
